<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model.ts'
import { ref } from 'vue'
import { useSendImportPassport } from './../model/api.ts'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VFilePickerField } from '@/shared/ui'

const { data, listTemplates, loadTemplates, rules, clearData } = useModel()
const { isFetching } = loadTemplates()

const { upload, isPending } = useSendImportPassport()

const emits = defineEmits(['uploaded'])

const valid = ref(false)

/**
 * Функция отправки данных на сервер
 */
const submitHandler = () => {
  if (!valid.value) return

  upload(data.value).then(() => {
    clearData()
    emits('uploaded')
  })
}
</script>

<template>
  <div class="form__grid_3">
    <div class="w-invent-passport-load">
      <p class="w-invent-passport-load__head">Импорт</p>

      <VForm class="mt-2" v-model="valid" @submit.prevent="submitHandler">
        <VSelect
          :label="$t('itf.import_template')"
          :items="listTemplates"
          :loading="isFetching"
          :rules="rules.import_template_id"
          item-title="name"
          item-value="id"
          v-model="data.import_template_id"
        />

        <VFilePickerField
          v-model="data.import_file"
          :label="$t('itf.import_file')"
          :rules="rules.import_file"
        />

        <VDateInput
          :rules="rules.ver_date"
          :label="$t('itf.choose_save_date')"
          v-model="data.ver_date"
          hide-details
        />

        <div class="form__btn_left">
          <VBtn type="submit" :loading="isPending">{{ $t('itf.importing') }}</VBtn>
        </div>
      </VForm>
    </div>
  </div>
</template>
